module.exports = __webpack_public_path__ + "static/media/BIG Jew day x.bf57cdae.JPG";